// extracted by mini-css-extract-plugin
export var fadeIn = "_mo-1";
export var modalContent = "_mo-3";
export var overlay = "_mo-0";
export var popoverContent = "_mo-2";
export var results = "_mo-5";
export var searchInputWrapper = "_mo-4";